import UpagoSection from "../../Widgets/UpagoSection/UpagoSection";
import BuyerIntentLandingPageBanner from "../../Widgets/V2/BuyerIntentLandingPageBanner/BuyerIntentLandingPageBanner";
import TabCardContainer from "../../Widgets/V2/TabCardContainer/TabCardContainer";
export var WIDGETS_MAPPER_V2 = {
  'olxmx-mobile-top-intent-widget-buy-tab': BuyerIntentLandingPageBanner,
  'olxcl-tabs-card': TabCardContainer,
  'olxcl-upago-section': UpagoSection
};